import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function Yoga() {
  const { i18n } = useTranslation('offer-package');

  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (i18n.language === 'de') {
    return (
      <div className="bg-white grid md:grid-cols-2">
        <div className="w-full h-full max-h-140">
          <img
            src="https://cdn.mandira-ayurveda.at/images/resort/2020/yoga.jpg"
            alt="Spa"
            className="w-full h-full object-cover"
          ></img>
        </div>

        <div className="bg-[#155f4f] print:bg-white px-4 py-5 flex items-center">
          <div className="flex flex-col items-start gap-8 md:ml-10 lg:ml-20 py-10">
            {!isOpen && (
              <Fragment>
                <p className="text-white uppercase print:text-black flex flex-col text-4xl space-y-2 font-light">
                  <span className="font-medium">Yoga & Meditation</span>
                  <span>zur inneren Mitte</span>
                </p>

                {/* <button
                  type="button"
                  className="uppercase text-white py-4 px-6 border-white border-2"
                  onClick={() => setIsOpen(true)}
                >
                  Mehr erfahren
                </button> */}
              </Fragment>
            )}

            {isOpen && (
              <Fragment>
                <button
                  type="button"
                  className="uppercase text-white bg-[#2ca67a] px-5 py-3 flex gap-2 items-center"
                  onClick={() => setIsOpen(false)}
                >
                  <ArrowLeftIcon className="size-6" /> zurück
                </button>

                <div className="text-white">
                  <p>
                    Unser Körper ist Bindeglied zwischen Geist und Umwelt.
                    Unseren Körper gesund und flexibel zu erhalten, ist eine
                    essenzielle Säule der ganzheitlichen Gesundheit. Mit unserem
                    Bewegungs- & Regenerationsprogramm steigern Sie Ihre
                    Fitness, nähren die Seele und bringen Geist und Körper in
                    Balance.
                  </p>

                  <p className="mt-2">Sie erwartet z.B.:</p>

                  <ul className="list list-disc ms-5">
                    <li>
                      Yoga & Meditation mit unseren Yoga- und
                      Mediationsexperten: Atemübungen (Pranayama),
                      Achtsamkeitsstunden
                    </li>
                    <li>
                      Bewegungs- und Entspannungsprogramm mit unseren
                      Bewegungsexperten: Heilthermal Smovey Aquafit,
                      Faszientraining, Rückenfit u. v. m.
                    </li>
                    <li>Training im Fitnessraum</li>
                    <li>
                      Verleih von Nordic-Walking-Stöcken und Smovey-Ringen
                    </li>
                    <li>
                      Fahrrad-Verleih (E-Bikes gegen Gebühr) inkl. Radhelm und
                      Radkarte
                    </li>
                    <li>Bücherecke und E-Book-Reader-Verleih</li>
                  </ul>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white grid md:grid-cols-2">
      <div className="w-full h-full max-h-140">
        <img
          src="https://cdn.mandira-ayurveda.at/images/resort/2020/yoga.jpg"
          alt="Spa"
          className="w-full h-full object-cover"
        ></img>
      </div>

      <div className="bg-[#155f4f] print:bg-white px-4 py-5 flex items-center">
        <div className="flex flex-col items-start gap-8 md:ml-10 lg:ml-20 py-10">
          {!isOpen && (
            <Fragment>
              <p className="text-white uppercase print:text-black flex flex-col text-4xl space-y-2 font-light">
                <span className="font-medium">Yoga & Meditation</span>
                <span>to the inner center</span>
              </p>

              {/* <button
                type="button"
                className="uppercase text-white py-4 px-6 border-white border-2"
                onClick={() => setIsOpen(true)}
              >
                Learn more
              </button> */}
            </Fragment>
          )}

          {isOpen && (
            <Fragment>
              <button
                type="button"
                className="uppercase text-white bg-[#2ca67a] px-5 py-3 flex gap-2 items-center"
                onClick={() => setIsOpen(false)}
              >
                <ArrowLeftIcon className="size-6" /> zurück
              </button>

              <div className="text-white">
                <p>
                  Our body is the link between our mind and our environment.
                  Keeping our body healthy and flexible is an essential pillar
                  of holistic health. of holistic health. With our exercise &
                  regeneration program regeneration program, you can increase
                  your fitness, nourish your soul and bring mind and body into
                  balance.
                </p>

                <p className="mt-2">You can expect e.g:</p>

                <ul className="list list-disc ms-5">
                  <li>
                    Yoga & meditation with our yoga and mediation experts:
                    Breathing exercises (pranayama), mindfulness classes
                  </li>
                  <li>
                    Exercise and relaxation program with our exercise experts:
                    Healing thermal Smovey Aquafit, fascia training, back
                    fitness and much more.
                  </li>
                  <li>Training in the fitness room</li>
                  <li>Nordic walking poles and Smovey rings for hire</li>
                  <li>
                    Bike rental (e-bikes for a fee) incl. bike helmet and bike
                    map
                  </li>
                  <li>Book corner and e-book reader rental</li>
                </ul>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

export default Yoga;
